import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const AuthorisationPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 py-12">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <FontAwesomeIcon 
            icon={faExclamationTriangle} 
            className="text-yellow-500 text-6xl"
          />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Accès non autorisé
        </h1>
        
        <p className="text-gray-600 mb-6">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </p>
        
        <div className="flex flex-col space-y-3">
          <Link 
            to="/" 
            className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition duration-200"
          >
            Retour à l'accueil
          </Link>
          
          <Link 
            to="/login" 
            className="text-blue-600 hover:text-blue-800 transition duration-200"
          >
            Se connecter avec un autre compte
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AuthorisationPage;